import { useEffect } from 'react'
import { serverConfig } from '@/config/server.config'
import { gtag } from './gtag'

const GA_SCRIPT_ID = 'google-analytics'

export function GoogleAnalyticsLoader() {
  useEffect(() => {
    const measurementId = serverConfig.googleAnalyticsMeasurementId

    if (!measurementId) {
      return
    }

    if (document.getElementById(GA_SCRIPT_ID)) {
      return
    }

    window.dataLayer = window.dataLayer || []
    window.gtag = gtag

    const script = document.createElement('script')
    script.id = GA_SCRIPT_ID
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`

    document.head.appendChild(script)

    window.gtag('js', new Date())
    window.gtag('config', measurementId)
  }, [])

  return null
}
